import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';

const API_URL = '/api/v1/phone-token/';
const SEARCH = 'search';
const DELETE = 'delete';

const getCustomerRegistration = (id) => {
	return axios.get(`${API_URL}/${id}`);
};

const getCustomerRegistrations = async ({ filterQuery, pageIndex, pageSize, sortBy, include = [] }) => {
	return await axios.post(`${API_URL}${SEARCH}`, {
		page: pageIndex,
		count: pageSize,
		sortBy,
		include: [
			"name",
			"phoneNumber",
			...include,
		],
		filters: [
			{
				type: 'string',
				name: 'name',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,

			},
			{
				type: 'string',
				name: 'phoneNumber',
				format: 'phoneNumber',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
			}
		],
	});
};

const searchCustomerRegistrationsByPhone = async ({ filterQuery, pageIndex, pageSize, sortBy }) => {
	return await axios.post(`${API_URL}${SEARCH}`, {
		page: pageIndex,
		count: pageSize,
		sortBy,
		include: [
			'phoneNumber',
			'token',
			'deviceType',
		],
		filters: [
			{
				type: 'string',
				name: 'phoneNumber',
				format: 'phoneNumber',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
			}
		],
	});
};

const deleteCustomerRegistrations = async (idsToDelete) => {
	return await axios.delete(`${API_URL}${DELETE}`, {
		data: { idsToDelete }
	});
};

export {
	getCustomerRegistration,
	getCustomerRegistrations,
	deleteCustomerRegistrations,
	searchCustomerRegistrationsByPhone,
};
